/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BagBriefcaseIcon16Solid = forwardRef('BagBriefcaseIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.5 0a2.25 2.25 0 0 0-2.25 2.25V3H3.5A2.5 2.5 0 0 0 1 5.5v.977L7.454 8.09c.359.09.733.09 1.092 0L15 6.477V5.5A2.5 2.5 0 0 0 12.5 3h-.75v-.75A2.25 2.25 0 0 0 9.5 0h-3Zm3.75 3v-.75a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V3h4.5Z" }),
        React.createElement("path", { d: "M12.5 14a2.5 2.5 0 0 0 2.5-2.5V8.023L8.91 9.546a3.75 3.75 0 0 1-1.82 0L1 8.023V11.5A2.5 2.5 0 0 0 3.5 14h9Z" })));
});
